<app-new-header *ngIf="tenant !='iltsc'"></app-new-header>
<app-success-header *ngIf="tenant ==='iltsc'"></app-success-header>
<!-- login body section open -->
<div class="UNFAPP-signlog-full-area">
  <div class="UNFAPP-signlog-frm-wrpbx">
    <div class="UNFAPP-signlog-frmbx">
      <div class="UNFAPP-signlog-hdng-wrap">
        <h2 class="UNFAPP-signlog-hdng">Enroll Now</h2>
        <h3 class="UNFAPP-signlog-stphdng">
          Please fill your details to enroll
        </h3>
      </div>

      <form [formGroup]="enrollnowForm">
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="UNFAPP-form-fld-row">
              <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                <span class="UNFAPP-frmicon"
                  ><img src="/assets/img/name-icon.png" alt=""
                /></span>
                <input
                  type="text"
                  class="UNFAPP-form-fld"
                  placeholder="First Name"
                  formControlName="firstName"
                />
              </div>
              <label
                class="UNFAPP-fld-error"
                *ngIf="
                  enroll.firstName.touched && enroll.firstName.errors?.required
                "
                >*Required</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12">
            <div class="UNFAPP-form-fld-row">
              <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                <span class="UNFAPP-frmicon"
                  ><img src="/assets/img/name-icon.png" alt=""
                /></span>
                <input
                  type="text"
                  class="UNFAPP-form-fld"
                  placeholder="Last Name"
                  formControlName="lastName"
                />
              </div>
              <label
                class="UNFAPP-fld-error"
                *ngIf="
                  enroll.lastName.touched && enroll.lastName.errors?.required
                "
                >*Required</label
              >
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <div class="UNFAPP-form-fld-row">
              <div
                class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon"
              >
                <span class="UNFAPP-frmicon">
                  <img src="/assets/img//phone-icon.png" alt=""
                /></span>
                <div class="UNFAPP-phncuntry-fldgrp">
                  <select>
                    <option selected>+91</option>
                  </select>
                  <input
                    type="text"
                    placeholder="Phone Number"
                    formControlName="phone"
                    maxlength="10"
                  />
                </div>
              </div>
              <label
                class="UNFAPP-fld-error"
                *ngIf="enroll.phone.touched && enroll.phone.errors?.required"
                >*Required</label
              >
              <mat-error
                class="UNFAPP-fld-error"
                *ngIf="enroll.phone.errors?.minlength"
              >
                *Mobile number should be 10 digits
              </mat-error>
              <mat-error
              class="UNFAPP-fld-error"
              *ngIf="enroll.phone.errors?.maxlength"
            >
              *Mobile number should be 10 digits
            </mat-error>
            </div>
          </div>
          <div class="col-md-4">
            <button
              type="button"
              class="enrollbtn-otp"
              id="btn-otp"
              *ngIf="!otpSent"
              (click)="verifyPhone()"
              [disabled]="!enrollnowForm.valid"
            >
              Send OTP
            </button>
            <a
              *ngIf="otpSent && !resendotp"
              class="enrolltxt-otp"
              id="txt-resend"
              >Resend OTP in {{ counter }} Sec</a
            >
            <button
              type="button"
              class="btn-resend"
              *ngIf="resendotp"
              (click)="verifyPhone()"
            >
              Resend OTP
            </button>
          </div>
        </div>
        <div class="row">
          <div *ngIf="otpSent" class="col-md-12" id="txt-edit">
            <p class="bold">
              Verify the OTP sent to +91 {{ enrollnowForm?.value.phone }}
              <a (click)='editNum()' class="float-right d-none d-sm-block">EDIT</a>
            </p>
          </div>
        </div>
        <div class="row">
          <div *ngIf="otpSent" class="col-md-12" id="txt-expire">
            <p class="txt-expr">
              OTP Expires in 15 mins
              <!-- <a href="#" class="float-right d-block d-sm-none">EDIT</a> -->
            </p>
          </div>
        </div>
        <div class="row">
          <!-- <div class="col-md-12" id="txt-verify">
            <input type="text" class="otp-box" />
            <input type="text" class="otp-box" />
            <input type="text" class="otp-box" />
            <input type="text" class="otp-box" />
            <button type="button" class="btn-verify" id="btn-verify">
              Verify
            </button>
            <label class="UNFAPP-fld-error textleft"
              >The OTP is incorrect, please enter again</label
            >
          </div> -->
          <div class="margin">
            <!-- <input type="text" formControlName="otp1" class="otp-box">
                          <input type="text" formControlName="otp2" class="otp-box">
                          <input type="text" formControlName="otp3" class="otp-box">
                          <input type="text" formControlName="otp4" class="otp-box"> -->
            <ng-otp-input
              *ngIf="otpSent"
              style="border-radius: 10px"
              (onInputChange)="onOtpChange($event); otpError = false"
              [config]="{ length: 4, allowNumbersOnly: true }"
            ></ng-otp-input>
          </div>
          <div>
            <button
              *ngIf="otpSent && !isOtpVerified"
              type="button"
              class="btn-verify"
              (click)="verifyOtp()"
              [disabled]="!otpValid || otpError"
            >
              Verify
            </button>
            <button
              *ngIf="isOtpVerified"
              type="button"
              class="btn-verify"
              [disabled]="true"
            >
              OTP Verified
            </button>
          </div>
        </div>
        <div class="row">
          <div class="margin">
            <label *ngIf="otpError" class="text-danger m-1">
              OTP is incorrect or expired. Try again
            </label>
            <label
              *ngIf="otpSent && !otpError && !isOtpVerified"
              class="text-success m-1"
            >
              OTP sent
            </label>
            <label *ngIf="isOtpVerified" class="text-success m-1">
              Your OTP for 
              +91 {{ enrollnowForm?.value.phone }} is verified
            </label>
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-md-12" id="txt-verified">
            <p>Your OTP for 97364737xxx is verified</p>
          </div>
        </div> -->
        <div class="row">
          <div class="col-md-12 col-lg-12 col-12">
            <div class="UNFAPP-update-txt">
              <!-- <input
                type="checkbox"
                checked
                formControlName="whatsappConsent"
              />
              <span>Receive updates on Whatsapp</span> -->
              <label class="whtapp-custom-checkbox">
                <input type="checkbox" formControlName="whatsappConsent" />
                <span>Receive updates on Whatsapp</span></label
              >
            </div>
            <p class="UNFAPP-terms-text">
              By signing up you agree to our
              <a (click)="openTermsAndConditionsDialog()">T&C</a> and
              <a (click)="openPrivacyPolicyDialog()">Privacy Policy</a>
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <button
              type="submit"
              class="enrollpage-btn"
              data-toggle="modal"
              data-target="#cbseten"
              [disabled]="!enrollnowForm.valid || !isOtpVerified"
              (click)="enrollNow()"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- login body section closed -->

<app-course-footer></app-course-footer>

